import { render, staticRenderFns } from "./MessageChatsWazzupSection.vue?vue&type=template&id=5961f95e&"
import script from "./MessageChatsWazzupSection.vue?vue&type=script&lang=js&"
export * from "./MessageChatsWazzupSection.vue?vue&type=script&lang=js&"
import style0 from "./MessageChatsWazzupSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports